if (!customElements.get('advanced-tabs')) {
  customElements.define(
    'advanced-tabs',
    class AdvancedTabs extends HTMLElement {
      constructor () {
        super();
        this.tabs = this.querySelectorAll('*[data-target]');
        console.log('this.tabs=', this.tabs);
        this.active = Array.from(this.tabs).find((item) => {item.classList.contains('active');});
        this.link = this.querySelector('.advanced-steps__subheading > a');
      }

      setActive (e) {
        const target = e.target.closest('li');
        target.classList.add('active');
        const activeHandle = target.getAttribute('data-target');
        if (activeHandle) {
          const activeTab = this.querySelector(`[data-id="${activeHandle}"]`);
          if (activeTab) {
            activeTab.classList.add('active');
          }
        }
        this.tabs.forEach((item) => {
          if (item !== target) {
            item.classList.remove('active');
            const handle = item.getAttribute('data-target');
            const relativeTab = this.querySelector(`[data-id="${handle}"]`);
            if (relativeTab) {
              relativeTab.classList.remove('active');
            }
          }
        });
      }

      linkClickHandle (e) {
        const link = e.target.closest('a');
        e.stopPropagation();
        e.preventDefault();
        const url = new URL(link.href);
        if (url.hash) {
          const dataID = url.hash.replace('#', '');
          const targets = document.querySelectorAll(`[data-id="${dataID}"]`);
          targets.forEach((target)=>{
            if (target.tagName === 'DETAILS' && !!(target && target.offsetParent) ) {
              const element = target.querySelector('summary');
              if (element) {
                if(element.getAttribute('aria-expanded') === 'false') {
                  element.click();
                }
                element.focus();
              }
            }
          });
        }
      }

      connectedCallback () {
        this.tabs.forEach((item) => {
          item.addEventListener('click', this.setActive.bind(this));
        });
        if (this.active) {
          this.active.dispatchEvent(new (Event('click')));
        }
        if (this.link) {
          this.link.setAttribute('data-scroll-to-disabled', '');
          this.link.addEventListener('click', this.linkClickHandle.bind(this));
        }
      }

      disconnectedCallback () {
        this.tabs.forEach((item) => {
          item.removeEventListener('click', this.setActive.bind(this));
        });
      }
    },
  );
}

